import React, { Component } from 'react';
import { connect } from 'react-redux';
import Translation from '../../utilities/localizationUtility';
import Button from '../../components/Common/Button';

class Index extends Component {
  render() {
    const { onSubmit, canBook, settings } = this.props;

    const t = new Translation(settings);

    return (
      <Button styled={settings.style.button} disabled={!canBook} className="submit ptb15" onClick={e => onSubmit(e)}>
        {canBook ? t.key('submit') : t.key('noAvailability')}
      </Button>
    );
  }
}

Index.propTypes = {};

export default connect(({ settings }) => ({
  settings,
}))(Index);
